// hooks/useMediosPago.js
import { useState, useEffect } from 'react';
import { UrlApi } from '../../../../../services/apirest';

export const useMediosPago = (tipo = "envasado") => {
  const [mediosPago, setMediosPago] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const obtenerMediosPago = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${UrlApi}/envasado_medios_pago/xnegocio/${tipo}`);
      if (!response.ok) throw new Error("Error al obtener medios de pago");
      const data = await response.json();
      setMediosPago(data);
    } catch (error) {
      console.error("Error obteniendo medios de pago:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const crearNuevoPago = async (datosPago) => {
    setLoading(true);
    try {
      const response = await fetch(`${UrlApi}/envasado_pagos_combinados`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosPago)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Error al crear el pago");
      }

      const nuevoPago = await response.json();
      return nuevoPago;
    } catch (error) {
      console.error("Error creando pago:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerMediosPago();
  }, [tipo]);

  return {
    mediosPago,
    loading,
    error,
    crearNuevoPago,
    obtenerMediosPago
  };
};